// extracted by mini-css-extract-plugin
export default {"navigationContainer":"XzP01r","navigation":"gOtyey"};